import { defineComponent as _defineComponent } from 'vue'

import Add from './icons/Add.vue';
import Cancel from './icons/Cancel.vue';
// define events

export default /*#__PURE__*/_defineComponent({
  props: {
  searchText: {
    type: String,
    required: true,
  },
  matchFound: {
    type: Boolean,
    required: true,
  },
},
  emits: ['update:searchText', 'submit'],
  setup(__props, { expose, emit }) {
  expose();

const props = __props





function submit(searchText: string) {
  if (searchText === '') {
    return;
  }
  emit('submit', searchText);
}

const __returned__ = { emit, props, submit, Add, Cancel }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})